export var LABEL_TYPE;
(function (LABEL_TYPE) {
    LABEL_TYPE[LABEL_TYPE["H1"] = 0] = "H1";
    LABEL_TYPE[LABEL_TYPE["H2"] = 1] = "H2";
    LABEL_TYPE[LABEL_TYPE["H3"] = 2] = "H3";
    LABEL_TYPE[LABEL_TYPE["H3_EXPANSION"] = 3] = "H3_EXPANSION";
    LABEL_TYPE[LABEL_TYPE["H4"] = 4] = "H4";
    LABEL_TYPE[LABEL_TYPE["H4_EXPANSION"] = 5] = "H4_EXPANSION";
    LABEL_TYPE[LABEL_TYPE["H5"] = 6] = "H5";
    LABEL_TYPE[LABEL_TYPE["H5_EXPANSION"] = 7] = "H5_EXPANSION";
    LABEL_TYPE[LABEL_TYPE["H6"] = 8] = "H6";
    LABEL_TYPE[LABEL_TYPE["BODY"] = 9] = "BODY";
    LABEL_TYPE[LABEL_TYPE["SMALL"] = 10] = "SMALL";
    LABEL_TYPE[LABEL_TYPE["EXTRA_SMALL"] = 11] = "EXTRA_SMALL";
    LABEL_TYPE[LABEL_TYPE["LARGE"] = 12] = "LARGE";
    LABEL_TYPE[LABEL_TYPE["EXTRA_LARGE"] = 13] = "EXTRA_LARGE";
})(LABEL_TYPE || (LABEL_TYPE = {}));
export var LabelTypeMap = new Map([
    [LABEL_TYPE.H1, "h1"],
    [LABEL_TYPE.H2, "h2"],
    [LABEL_TYPE.H3, "h3"],
    [LABEL_TYPE.H3_EXPANSION, "h3"],
    [LABEL_TYPE.H4, "h4"],
    [LABEL_TYPE.H4_EXPANSION, "h4"],
    [LABEL_TYPE.H5, "h5"],
    [LABEL_TYPE.H5_EXPANSION, "h5"],
    [LABEL_TYPE.H6, "h6"],
    [LABEL_TYPE.BODY, "p"],
    [LABEL_TYPE.SMALL, "p"],
    [LABEL_TYPE.EXTRA_SMALL, "p"],
    [LABEL_TYPE.LARGE, "p"],
    [LABEL_TYPE.EXTRA_LARGE, "p"],
]);
export var LABEL_STYLE;
(function (LABEL_STYLE) {
    LABEL_STYLE[LABEL_STYLE["BOLD"] = 0] = "BOLD";
    LABEL_STYLE[LABEL_STYLE["REGULAR"] = 1] = "REGULAR";
    LABEL_STYLE[LABEL_STYLE["LINK"] = 2] = "LINK";
    LABEL_STYLE[LABEL_STYLE["DEFAULT"] = 3] = "DEFAULT";
    LABEL_STYLE[LABEL_STYLE["OPEN"] = 4] = "OPEN";
    LABEL_STYLE[LABEL_STYLE["ITALIC"] = 5] = "ITALIC";
    LABEL_STYLE[LABEL_STYLE["ITALIC_LINK"] = 6] = "ITALIC_LINK";
    LABEL_STYLE[LABEL_STYLE["BOLD_LINK"] = 7] = "BOLD_LINK";
    LABEL_STYLE[LABEL_STYLE["LIGHT"] = 8] = "LIGHT";
    LABEL_STYLE[LABEL_STYLE["LIGHT_LINK"] = 9] = "LIGHT_LINK";
})(LABEL_STYLE || (LABEL_STYLE = {}));
